import request from "@/utils/request1";

/**
 * 评审业务服务接口
 */
const reviewBusinessService = {};

let commonUrl = "/review-api";

reviewBusinessService.saveSigData = function (params) {
    return request({
        url: "/review-business/save-signature",
        method: "post",
        baseURL: commonUrl,
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        },
        data: params
    });
}

export default reviewBusinessService;
